(function($){

	let $form = $("form.checkout_form"),
		$shipping_fields = $form.find(".woocommerce-shipping-fields")

    // Hide shipping fields on page load when a custom shipping method is selected
    let selected_method = $form.find("input[name='shipping_method']:checked")
    if (selected_method && selected_method.data("method-id") !== 'custom'){
        $shipping_fields.hide()
    }

	$(document).gp_ready(function(){

		// Open widget on shipping method change to "dpd_parcel_shop"
		$form.find("input[name='shipping_method']").change(function(){
			let method_id = $(this).data("method-id")
			if(method_id === "dpd_parcel_shop"){
				// Open widget
				open_widget()
				// Hide shipping address fields
				$shipping_fields.hide()
			}else if (method_id === "custom"){
				// Close widget
				close_widget()
				// Show shipping address fields
				$shipping_fields.show()
			}
		})

		// Open widget on choose button click
		$form.find('.dpd_select-btn').off("click").click(function(){
			open_widget()
		});

        // Callback listener
        window.addEventListener("message", (event) => {
            if (typeof event.data === 'undefined' || !event.data.dpdWidget) {
                return;
            }

            if (event.data.dpdWidget.message === "widgetClose") {
                close_widget();
                return;
            }

            if (event.data.dpdWidget.pickupPointResult) {
                widget_callback(event.data.dpdWidget);
                close_widget();
            }
        });

        update_data_from_session()
	})

	function open_widget(){

		let country = $form.find("select[name='billing_country'], input[name='billing_country']").val()
		if(!country){
			alert("Nebyla vybrána země doručení.")
			return
		}

		// Open widget
        const modal = $('.dpd_select.modal')
        modal.addClass('modal--open')
	}

	// Close
	function close_widget(){
        const modal = $('.dpd_select.modal')
        modal.removeClass('modal--open')
	}

	function widget_callback(locationData) {
		if (locationData != null && typeof locationData !== "undefined") {

			// house number can be included in the street address and is included separately in the propertyNumber field
            const street = locationData.location.address.street;
            const propertyNumber = locationData.location.address.propertyNumber;

            let address_1, address_2;

            if (street.endsWith(propertyNumber)) {
                address_1 = street.slice(0, -propertyNumber.length).trim();
                address_2 = propertyNumber;
            } else {
                address_1 = street;
                address_2 = propertyNumber;
            }

            const parsedData = {
                "address_full": locationData.location.address.street,
                "address_1": address_1,
                "address_2": address_2,
                "city": locationData.location.address.city,
                "country": locationData.location.address.country.toUpperCase(),
                "zip": locationData.location.address.zip,
                "url": locationData.url,
                "name": locationData.name,
                "id":locationData.id,
            }

			fill_inputs(parsedData)

			// Save the data into the session to be able to access it in the second step
			sessionStorage.setItem( "gp_dpd_branch_info", JSON.stringify(parsedData) );

			// Display chosen pickup point
			display_chosen_pickup_point(parsedData)

			return true;
		}

		return false;
	}

    function fill_inputs(parsedData){
        jQuery("input[name='dpd_shipping_address_1']").val(parsedData.address_1);
        jQuery("input[name='dpd_shipping_address_2']").val(parsedData.address_2);
        jQuery("input[name='dpd_shipping_city']").val(parsedData.city);
        jQuery("input[name='dpd_shipping_company']").val(parsedData.name);
        jQuery("input[name='dpd_shipping_country']").val(parsedData.country);
        jQuery("input[name='dpd_shipping_postcode']").val(parsedData.zip);
        jQuery("input[name='dpd_branch_id']").val(parsedData.id);
    }

	function display_chosen_pickup_point(locationData){

        // Change button text
        const btn = $form.find("a.dpd_select-btn")
        if (btn){
            btn.text(btn.data('label-change'));
        }

		// Display address
		$form.find(".dpd_branch").show();
		let addressOutput = locationData.name + '<br>' + locationData.address_full;
		$form.find("p#dpd_branch-address").html(addressOutput);
	}

	function update_data_from_session(){

		let locationData = sessionStorage.getItem("gp_dpd_branch_info")
		if(!locationData){
			return;
		}

		locationData = JSON.parse(locationData)
		fill_inputs(locationData)
        display_chosen_pickup_point(locationData)
	}

})(jQuery)
